import axios from 'axios';
import Toast from '../components/Toast'
import bxlutils from 'bxl-utils'
import { platform } from '../lib/platform'
import { BXL_USER_ID, prodPath, dogfoodPath } from '../lib/constants'

const DEVICE_ID = 'BXL_META_device_id';

let basePath
if (process.env.REACT_APP_BASE_ENV === 'dev') {
  basePath = dogfoodPath()
} else {
  basePath = prodPath()
}
let uuid = '';
let uid = '';
if (localStorage.getItem(BXL_USER_ID)) {
  uuid = localStorage.getItem(BXL_USER_ID) || '';
}
if (uuid) {
  let uids = uuid.split('-')
  uid = uids[uids.length - 1]
}

const http = axios.create({
  baseURL: basePath,
  headers: {}
})

const errorMessage = (error) => {
  let message = null;
  if (error.response) {
    error = error.response.data
  }
  if (error.messages && error.messages.length > 0) {
    message = error.messages[0];
  } else if (error.errors && error.errors.length > 0) {
    message = error.errors[0];
  } else if (error.message) {
    message = error.message;
  }

  return message;
}
http.interceptors.request.use(function (config) {
  let queryItem = bxlutils.uri.parseUrlParams(window.location.href)
  config.headers = {
    ...config.headers,
    "X-Session-Key": localStorage.getItem('BXL_USER_KEY') || '',
    "X-Session-User": localStorage.getItem('BXL_USER_ID') || '',
    'X-BXL-User-Agent': `Bieyang H5WB/${platform} 0.1.0 (${bxlutils.platform.getOS()} ${bxlutils.platform.getVersion()}; UID ${
      uid || ''
      })${queryItem.channel}`
  }
  // 在发送请求之前做些什么
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 添加响应拦截器
http.interceptors.response.use(function (response) {
  // 对响应数据做点什么
  return response;
}, function (error) {
  console.log(errorMessage(error))
  Toast.info(errorMessage(error), 1.5)
  // 对响应错误做点什么
  return Promise.reject(error);
});

export default http